(() => {
  const storageKey = 'mksmt:wishlist';
  const legacyKeys = ['wishlist', 'favorites'];

  const strings = {
    add: 'お気に入りに追加',
    remove: 'お気に入り済み',
    copied: 'リンクをコピーしました',
    copyFailed: 'リンクをコピーできませんでした',
    empty: '現在、お気に入り商品は登録されていません。',
    count: (count) => `お気に入り ${count}件`,
  };

  const readArray = (key) => {
    try {
      const value = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const normalizeHandle = (item) => {
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item).trim();
    }

    if (item && typeof item === 'object') {
      return String(item.handle || item.id || '').trim();
    }

    return '';
  };

  const uniqueHandles = (items) => {
    return [...new Set(items.map(normalizeHandle).filter(Boolean))];
  };

  const getWishlist = () => {
    let hasCurrentStorage = false;

    try {
      hasCurrentStorage = window.localStorage.getItem(storageKey) !== null;
    } catch (error) {
      hasCurrentStorage = false;
    }

    const sourceItems = hasCurrentStorage
      ? readArray(storageKey)
      : [readArray(storageKey), ...legacyKeys.map(readArray)].flat();

    const handles = uniqueHandles(sourceItems);

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(handles));
    } catch (error) {}

    return handles;
  };

  const setWishlist = (handles) => {
    const cleanHandles = uniqueHandles(handles);

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(cleanHandles));
    } catch (error) {
      return cleanHandles;
    }

    return cleanHandles;
  };

  const escapeHtml = (value) => {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  };

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'JPY';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'ja-JP',
        {
          style: 'currency',
          currency,
          maximumFractionDigits: currency === 'JPY' ? 0 : 2,
        }
      ).format(amount);
    } catch (error) {
      return `¥${Math.round(amount).toLocaleString()}`;
    }
  };

  const setButtonState = (button, active) => {
    const addLabel = button.dataset.addLabel || strings.add;
    const removeLabel = button.dataset.removeLabel || strings.remove;
    const productTitle = button.dataset.productTitle || '';

    const label = active ? removeLabel : addLabel;
    const labelNode = button.querySelector('[data-wishlist-label]');

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute(
      'aria-label',
      productTitle ? `${label}: ${productTitle}` : label
    );

    if (labelNode) {
      labelNode.textContent = label;
    }
  };

  const syncButtons = () => {
    const handles = getWishlist();
    const count = handles.length;

    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      setButtonState(
        button,
        handles.includes(button.dataset.productHandle)
      );
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
      node.textContent = count;
    });

    document
      .querySelectorAll('[data-wishlist-count-bubble]')
      .forEach((node) => {
        node.hidden = count === 0;
      });

    document.querySelectorAll('[data-wishlist-summary]').forEach((node) => {
      node.textContent =
        count > 0 ? strings.count(count) : strings.empty;
    });
  };

  const toggleWishlist = (handle) => {
    if (!handle) return;

    const current = getWishlist();

    const next = current.includes(handle)
      ? current.filter((item) => item !== handle)
      : [...current, handle];

    setWishlist(next);

    syncButtons();
    renderWishlistPage();
  };

  const getProductImage = (product) => {
    if (!product.featured_image) return '';

    if (typeof product.featured_image === 'string') {
      return product.featured_image;
    }

    return product.featured_image.src || '';
  };

  const productCardHtml = (product, handle) => {
    const url = product.url || `/products/${handle}`;
    const image = getProductImage(product);
    const variantId = product.variants?.[0]?.id || '';

    const imageHtml = image
      ? `
        <img
          class="wishlist-card__image"
          src="${escapeHtml(image)}"
          alt="${escapeHtml(product.title)}"
          loading="lazy"
        >
      `
      : '';

    return `
      <li class="wishlist-card" data-wishlist-item="${escapeHtml(handle)}">

        <a class="wishlist-card__image-link" href="${escapeHtml(url)}">
          ${imageHtml}
        </a>

        <div class="wishlist-card__body">

          <h2 class="wishlist-card__title">
            <a href="${escapeHtml(url)}">
              ${escapeHtml(product.title)}
            </a>
          </h2>

          <p class="wishlist-card__price">
            ${formatMoney(product.price)}
          </p>

          <div class="wishlist-card__actions">

            <a
              class="button button--secondary"
              href="${escapeHtml(url)}"
            >
              商品を見る
            </a>

            <form
              method="post"
              action="/cart/add"
              class="wishlist-card__cart-form"
            >
              <input
                type="hidden"
                name="id"
                value="${escapeHtml(variantId)}"
              >

              <button
                type="submit"
                class="button wishlist-card__cart-button"
              >
                カートに入れる
              </button>
            </form>

          </div>

          <button
            type="button"
            class="wishlist-remove-button"
            data-wishlist-remove
            data-product-handle="${escapeHtml(handle)}"
          >
            お気に入りから削除
          </button>

        </div>
      </li>
    `;
  };

  const missingProductHtml = (handle) => `
    <li
      class="wishlist-card wishlist-card--missing"
      data-wishlist-item="${escapeHtml(handle)}"
    >
      <div class="wishlist-card__body">
        <p>この商品は現在表示できません。</p>

        <button
          type="button"
          class="wishlist-remove-button"
          data-wishlist-remove
          data-product-handle="${escapeHtml(handle)}"
        >
          お気に入りから削除
        </button>
      </div>
    </li>
  `;

  const renderWishlistPage = async () => {
    const container = document.querySelector('[data-wishlist-page]');

    if (!container) return;

    const grid = container.querySelector('[data-wishlist-grid]');
    const empty = container.querySelector('[data-wishlist-empty]');

    if (!grid || !empty) return;

    const handles = getWishlist();

    syncButtons();

    if (handles.length === 0) {
      grid.innerHTML = '';
      grid.hidden = true;
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    grid.hidden = false;

    grid.innerHTML = '<li>読み込み中...</li>';

    const cards = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(
            `/products/${encodeURIComponent(handle)}.js`
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch ${handle}`);
          }

          const product = await response.json();

          return productCardHtml(product, handle);

        } catch (error) {
          return missingProductHtml(handle);
        }
      })
    );

    grid.innerHTML = cards.join('');
  };

  const shareProduct = async (button) => {
    const url = button.dataset.shareUrl || window.location.href;
    const title = button.dataset.shareTitle || document.title;

    const status = button
      .closest('[data-product-actions]')
      ?.querySelector('[data-share-status]');

    const setStatus = (message) => {
      if (!status) return;

      status.textContent = message;

      window.setTimeout(() => {
        if (status.textContent === message) {
          status.textContent = '';
        }
      }, 3000);
    };

    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        return;
      }

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const textarea = document.createElement('textarea');

        textarea.value = url;
        textarea.setAttribute('readonly', '');

        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);

        textarea.select();

        document.execCommand('copy');

        textarea.remove();
      }

      setStatus(strings.copied);

    } catch (error) {
      if (error?.name !== 'AbortError') {
        setStatus(strings.copyFailed);
      }
    }
  };

  document.addEventListener('click', (event) => {

    const wishlistButton = event.target.closest(
      '[data-wishlist-button]'
    );

    if (wishlistButton) {
      event.preventDefault();

      toggleWishlist(
        wishlistButton.dataset.productHandle
      );

      return;
    }

    const removeButton = event.target.closest(
      '[data-wishlist-remove]'
    );

    if (removeButton) {
      event.preventDefault();

      const handle = removeButton.dataset.productHandle;

      setWishlist(
        getWishlist().filter((item) => item !== handle)
      );

      syncButtons();
      renderWishlistPage();

      return;
    }

    const shareButton = event.target.closest(
      '[data-share-button]'
    );

    if (shareButton) {
      event.preventDefault();
      shareProduct(shareButton);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', () => {
    syncButtons();
    renderWishlistPage();
  });

  window.addEventListener('storage', (event) => {
    if (
      event.key === storageKey ||
      legacyKeys.includes(event.key)
    ) {
      syncButtons();
      renderWishlistPage();
    }
  });

})();